import React,{useEffect,useRef}from "react";
import {Box,Typography,Button,useTheme}from "@mui/material";
import gsap from "gsap";
import BecomePartner from "./becomePartner";
import { setupPartnersAnimation } from "../animations";
import { colors } from "../../../../theme/colors";
import typography from "../../../../theme/typography";

import chainlinkImg from "../../../../static/Images/partners/chainlink.png";
import polygonImg from "../../../../static/Images/partners/polygon.png";
import binanceImg from "../../../../static/Images/partners/binance.png";
import coinGeckoImg from "../../../../static/Images/partners/coinGecko.png";
import metaMaskImg from "../../../../static/Images/partners/MetaMask.png";
import trustWalletImg from "../../../../static/Images/partners/TrustWallet.png";
import walletConnectImg from "../../../../static/Images/partners/WalletConnect.png";

const partners=[
  {
    name:"Chainlink",
    className:"partner-chainlink",
    image: chainlinkImg
  },
  {
    name:"Polygon",
    className:"partner-polygon",
    image: polygonImg
  },
  {
    name:"Binance",
    className:"partner-binance",
    image: binanceImg
  },
  {
    name:"CoinGecko",
    className:"partner-coingecko",
    image: coinGeckoImg
  },
  {
    name:"MetaMask",
    className:"partner-metamask",
    image: metaMaskImg
  },
  {
    name:"Trust Wallet",
    className:"partner-trust",
    image: trustWalletImg
  },
  {
    name:"WalletConnect",
    className:"partner-walletconnect",
    image: walletConnectImg
  }
];

const Partners=()=>{
  const sectionRef=useRef(null);
  const partnerRefs=useRef([]);
  const theme=useTheme();

  useEffect(()=>{
    const section=sectionRef.current;
    const partnerCards=partnerRefs.current;

    if(!section)return;

    let cleanupAnimation;
    const ctx=gsap.context(()=>{
      cleanupAnimation = setupPartnersAnimation(section, partnerCards);
    },section);

    return()=>{
      if (cleanupAnimation) cleanupAnimation();
      ctx.revert();
    };
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="partners-section"
      sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        background: theme.palette.background.paper,
        color: colors.home.navyDeep,
        pt: '20px',
        pb: '20px',
        px: '40px',
      }}
    >

      <Box className="partners-header" sx={{
        ...(typography.homeSection?.headerContainer || {}),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        mb: "40px",
      }}>
        <Typography component="p" className="partners-eyebrow" sx={(theme) => ({
          ...(typography.homeSection?.eyebrow || {}),
          color: theme.custom?.colors?.home?.brandRed || colors.home.brandRed || "#FF0000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&::before": {
            ...(typography.homeSection?.eyebrow?.["&::before"] || {}),
            background: theme.custom?.colors?.home?.brandRed || colors.home.brandRed || "#FF0000",
          },
          "&::after": {
            ...(typography.homeSection?.eyebrow?.["&::before"] || {}),
            background: theme.custom?.colors?.home?.brandRed || colors.home.brandRed || "#FF0000",
            content: '""',
            display: "block",
            marginLeft: { xs: "8px", md: "16px" },
          },
        })}>
          OUR PARTNERS
        </Typography>

        <Typography component="h2" className="partners-heading" sx={(theme) => ({
          ...(typography.homeSection?.heading || {}),
          color: theme.custom?.colors?.home?.navyDark || colors.home.navyDeep || "#000000",
          textAlign: "center",
        })}>
          Building the future together.
        </Typography>

        <Typography component="p" className="partners-description" sx={{
          ...(typography.homeSection?.description || {}),
          color: "text.secondary",
          textAlign: "center",
          mx: "auto",
          maxWidth: "650px",
        }}>
          Working with trusted technology and ecosystem partners
          to build a secure, transparent, and reliable gaming platform.
        </Typography>
      </Box>

      <Box className="partners-stage" sx={{
        position: "relative",
        width: "100%",
        overflow: "hidden",
        padding: { xs: '0px 0 5px', md: '0px 0 15px' },
      }}>

        <Box className="partners-row" sx={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: '5px 10px', sm: '5px 15px', md: '5px 20px' },
          padding: { xs: '0 20px', md: '0 6%' },
          willChange: "transform",
        }}>
          {partners.map((partner,index)=>(
            <Box
              key={partner.name}
              ref={element=>{
                partnerRefs.current[index]=element;
              }}
              className={`partner-card ${partner.className}`}
              sx={{
                position: "relative",
                width: { xs: '160px', sm: '200px', md: '240px', lg: '280px' },
                height: { xs: '80px', sm: '100px', md: '120px', lg: '140px' },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                cursor: "default",
                willChange: "transform",
              }}
            >
              <Box component="img" src={partner.image} alt={partner.name} className="partner-logo" sx={{
                position: "relative",
                zIndex: 1,
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }} />
            </Box>
          ))}
        </Box>

      </Box>

      <BecomePartner />

    </Box>
  );
};

export default Partners;